const modalTriggerSelector = '[data-toggle="modal"]'
const modalCloseSelector = '[data-modal-close]'
const activeClass = '--js-modal-open'
const closingClass = '--js-modal-closing'

const modalOpenInit = () => {
    const modalTriggers = document.querySelectorAll(modalTriggerSelector)
    if (!modalTriggers) return
    modalTriggers.forEach(trigger => {
        trigger.addEventListener('click', (event) => {
            event.preventDefault()
            openModal(event)
        })
    })
}

const modalsInit = () => {
    modalOpenInit();
}

// initially there was only the document event listener on load, but in some cases the event was already triggered before and sometimes then it didnt trigger at all
if (document.readyState !== "loading") {
    modalsInit()
} else {
    document.addEventListener("DOMContentLoaded", function () {
        modalsInit()
    });
}

document.addEventListener('ajaxComplete', function () {
    modalsInit();
});

const openModal = (event) => {
    let button = event.target
    if (!button.hasAttribute('data-toggle')) {
        button = button.closest(modalTriggerSelector)
    }
    const targetId = button.dataset.target
    const modalWrapper = document.getElementById(targetId)

    if (!modalWrapper) return

    const modalBox = modalWrapper.querySelector('.base-modal__box')

    try {
        manageBody()
        modalWrapper.classList.add(activeClass)
        modalBox.classList.add(activeClass)

    } catch (error) {
        console.warn('Mondal with id ' + targetId + ' does not exist.')
    }


    document.addEventListener("click", closeModalHandler);
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
            closeModal(targetId)
        }
    });

}

const closeModalHandler = (event) => {
    let id = null
    let clickedElement = event.target

    if (clickedElement.hasAttribute('data-modal-close')) {
        id = clickedElement.dataset.modalClose
    }

    if (clickedElement.hasAttribute('data-modal') && clickedElement.hasAttribute('id')) {
        id = clickedElement.id
    }

    const parentCloser = clickedElement.closest(modalCloseSelector)

    if (parentCloser && parentCloser.hasAttribute('data-modal-close')) {
        id = parentCloser.dataset.modalClose
    }

    if (id) {
        closeModal(id)
    }

}

const closeModal = (id) => {
    const modalWrapper = document.getElementById(id)
    const modalBox = modalWrapper.querySelector('.base-modal__box')

    try {
        manageBodyClose()
        modalWrapper.classList.add(closingClass)
        modalBox.classList.add(closingClass)

        setTimeout(() => {
            modalWrapper.classList.remove(activeClass, closingClass)
            modalBox.classList.remove(activeClass, closingClass)
        }, 300)

    } catch (error) {
        console.warn('Mondal with id ' + id + ' does not exist.')
    }

}

const getScrollbarWidth = () => {
    return window.innerWidth - document.documentElement.clientWidth
}

const manageBody = () => {
    const body = document.body
    body.style.paddingRight = getScrollbarWidth() + 'px'
    body.style.overflow = 'hidden'
}

const manageBodyClose = () => {
    const body = document.body
    body.style.padding = null
    body.style.overflow = null
}
